var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.service)?_c('article',{staticClass:"service-teaser card"},[_c('figure',[_c('img',{attrs:{"src":_vm.service.image,"alt":""}})]),_c('div',{staticClass:"card-content"},[_c('h3',{staticClass:"title is-4"},[_vm._v(_vm._s(_vm.service.title))]),_c('p',[_vm._v(_vm._s(_vm.service.excerpt))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }